import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Textarea,
} from '@fluentui/react-components';

type TProps = {
  open: boolean;
  onDismissFinding: (reason: string) => void;
  onClose: () => void;
};

export const DismissFindingDialog = ({ open, onDismissFinding, onClose }: TProps) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Mark as not applicable</DialogTitle>
          <DialogContent>
            <Field label="Justification" required>
              <Textarea
                value={reason}
                onChange={(_, data) => setReason(data.value)}
                placeholder="Why this finding does not apply"
                resize="vertical"
              />
            </Field>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button appearance="primary" disabled={!reason.trim()} onClick={() => onDismissFinding(reason.trim())}>
              Confirm
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
